import React from 'react';
import FeatureItem from './FeatureItem';

const BankingHero = () => {
  return (
    <div className="flex-1 max-md:w-full">
      <h1 className="mb-4 text-5xl font-bold leading-tight text-teal-600 max-md:text-4xl max-sm:text-3xl">
        Integrated with Banking/Financial Technology
      </h1>
      <p className="mb-6 text-xl font-medium text-amber-500 max-md:text-lg max-sm:text-base">
        Enterprise-grade power, simplified.
      </p>
      <p className="mb-8 text-base leading-relaxed text-slate-600 max-md:text-base">
        We leverage secure banking integrations to automate your
        reconciliation process, streamline your payouts, and provide a
        single source of truth for your business finances.
      </p>
      <ul className="flex flex-col gap-4">
        <FeatureItem>
          Direct Bank Connectivity: real-time balance monitoring.
        </FeatureItem>
        <FeatureItem>
          Reduced Human Error: eliminate the risk missed entries.
        </FeatureItem>
      </ul>
    </div>
  );
};

export default BankingHero;
